// components/pricing/AnnualPlan.tsx
import React from 'react';

const AnnualPlan: React.FC = () => {
  return (
    <>
      <p className="text-lg font-bold">Annual</p>
      <p className="text-gray-500 line-through text-sm">$29.98/month</p>
      <p className="text-4xl font-extrabold text-gray-900">
        $14.99<span className="text-xl font-normal">/month</span>
      </p>
      <p className="text-gray-500 text-sm">billed annually ($179.88)</p>
    </>
  );
};

export default AnnualPlan;
